// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__10gMJ","bar":"header_bar__1KDoK","title":"header_title__1wORw","is_not_auth":"header_is_not_auth__3kmNN","mx2":"header_mx2__1_Wrk"};